module.exports = __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/assessment_incomplete_2-1136de91c4201c27d6f123cb453a1e63.svg";